import { MpsRole, MpsUser } from '../models/mps-user.model';

export class MpsRoleHelper {
  // MPS default roles
  static readonly USER = 'USER';
  static readonly ADMIN = 'ADMIN';

  // FLOW application roles
  static readonly PRM = 'PRM';
  static readonly ANALYST = 'ANALYST';
  static readonly BRANCH_DSI_ABP = 'BRANCH_DSI_ABP';
  static readonly PGM = 'PGM';
  static readonly GUEST = 'GUEST';
  static readonly PRODUCT_OWNER = 'PRODUCT_OWNER';
  static readonly FI_REQUEST_MANAGER = 'FI_REQUEST_MANAGER';
  static readonly TGITS_GUEST = 'TGITS_GUEST';

  static getRoles(): MpsRole[] {
    return [
      { id: 1, code: MpsRoleHelper.ADMIN, label: 'Admin' },
      { id: 2, code: MpsRoleHelper.PRM, label: 'PRM' },
      { id: 3, code: MpsRoleHelper.ANALYST, label: 'Analyst' },
      { id: 4, code: MpsRoleHelper.BRANCH_DSI_ABP, label: 'Branch DSI ABP' },
      { id: 5, code: MpsRoleHelper.PGM, label: 'PGM' },
      { id: 6, code: MpsRoleHelper.GUEST, label: 'Guest' },
      { id: 7, code: MpsRoleHelper.PRODUCT_OWNER, label: 'Product Owner' },
      { id: 8, code: MpsRoleHelper.FI_REQUEST_MANAGER, label: 'FI Request Manager' },
      { id: 9, code: MpsRoleHelper.TGITS_GUEST, label: 'TGITS Guest' },
      { id: 10, code: MpsRoleHelper.USER, label: 'User' },
    ];
  }

  static getAllRoleCodes(): string[] {
    return MpsRoleHelper.getRoles().map(role => role.code);
  }

  static findRole(roles: MpsRole[], roleCode: string): MpsRole {
    return roles.find((role: MpsRole) => role.code.toUpperCase() === roleCode.toUpperCase())!;
  }

  static getRoleIdFromCode(roleCode: string): number {
    return MpsRoleHelper.findRole(MpsRoleHelper.getRoles(), roleCode).id;
  }

  static getRoleCodeForTranslation(roleCode: string): string {
    return 'entities.roles.' + roleCode.toLowerCase().replace(/-/g, '_');
  }

  static hasRole(user: MpsUser, roleCode: string): boolean {
    return user.role && user.role.code.toUpperCase() === roleCode.toUpperCase();
  }

  static hasAnyRole(user: MpsUser, roleCodes: string[]): boolean {
    return user.role && roleCodes.map(rc => rc.toUpperCase()).includes(user.role.code.toUpperCase());
  }

  static isProductOwner(user: MpsUser): boolean {
    return user.role_id === MpsRoleHelper.getRoleIdFromCode(MpsRoleHelper.PRODUCT_OWNER);
  }
}
